import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { MaterialModule } from "src/app/material.module";
import { SharedModule } from "src/app/shared.module";
import { UiScrollModule } from "ngx-ui-scroll";
import { PhotoSelectorComponent } from "./photo-selector.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MaterialModule,
        SharedModule,
        UiScrollModule
    ],
    declarations: [PhotoSelectorComponent],
    exports: [PhotoSelectorComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
    
})
export class PhotoSelectorModule {}